import { style, media } from "typestyle";
import { colors, queries } from "styles/styles";

export const wrapper = style(
  {
    display: "flex",
    alignSelf: "center",
    marginTop: "5rem"
  },
  media(queries.medium, {
    marginTop: "5rem"
  })
);

export const loadingContainer = style(
  {
    display: "flex",
    alignSelf: "center",
    marginTop: "5rem"
  },
  media(queries.medium, {
    marginTop: "5rem"
  })
);

export const container = style(
  {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: colors.hooplaTextColor,
    borderRadius: "9px",
    width: "100%",
    margin: "0 1rem",
    textAlign: "center",
    padding: "3rem 1rem",
    backgroundColor: colors.hooplaBackgroundDarker
  },
  media(queries.medium, {
    backgroundColor: colors.hooplaBackgroundDarker,
    margin: 0,
    padding: "3rem",
    maxWidth: "35rem"
  })
);

export const successHeader = style({
  marginBottom: "1rem"
});

export const headerContainer = style({
  fontSize: "1.75rem",
  marginBottom: "1.25rem",
  fontWeight: 300
});

export const marginBottom = style({
  marginBottom: "1rem"
});

export const inputWrapper = style({
  marginTop: "3rem",
  width: "100%",
  display: "flex"
});
